import { DataGridPremium, DataGridPremiumProps } from "@mui/x-data-grid-premium";

interface CatalogueGridProps extends DataGridPremiumProps {
}

export const CatalogueGrid = (props: CatalogueGridProps) => {
    const {
        columns,
        rows,
        rowCount,
        pageSizeOptions = [5, 10, 20, 50, 100, 500],
        paginationMode = 'server',
        sortingMode = 'server',
        filterMode = 'server',
        ...other
    } = props;

    return (
        <DataGridPremium
            pagination
            filterMode={filterMode}
            rows={rows}
            columns={columns}
            rowCount={rowCount ? rowCount : rows ? rows?.length : 0}
            paginationMode={paginationMode}
            sortingMode={sortingMode}
            pageSizeOptions={pageSizeOptions}
            cellSelection
            disableAggregation
            disableColumnSorting
            showToolbar
            disablePivoting
            localeText={{
                noRowsLabel: 'No records found',
                noResultsOverlayLabel: 'No results'
            }}
            {...other}
        />
    );
};


// function Toolbar(props: GridToolbarProps) {
//     const commonSlotProps: GridToolbarExportProps['slotProps'] = { button: { size: 'small' } }

//     return (
//         <GridToolbarContainer {...props} sx={{ py: 1, px: 2, justifyContent: 'space-between' }} >
//             <GridToolbarQuickFilter
//                 slotProps={{
//                     root: {
//                         size: 'small',
//                         placeholder: "Search current context",
//                         // InputProps: {
//                         //     sx: { borderRadius: 1.5 },
//                         //     startAdornment: <SearchOutlined color='secondary' fontSize='small' />,
//                         //     slotProps: {
//                         //         input: {
//                         //             sx: { py: 0 }
//                         //         }
//                         //     }
//                         // }
//                     }
//                 }}
//             />
//             <Stack direction='row' justifyContent='end' flexWrap='nowrap' gap={1} >
//                 <GridToolbarDensitySelector slotProps={commonSlotProps} />
//                 <GridToolbarFilterButton slotProps={commonSlotProps} />
//             </Stack>
//         </GridToolbarContainer>
//     )
// }
